<template>
  <div id="evaluate-category2">
    <div v-if="disableshow" class="dishandle">
      <div class="disdiv">
        <img width="50px" style="margin-top: 32px;" src="../assets/error_icon.png" />
        <div class="div_ti">无法识别</div>
        <div style="color: #808080;font-size: 14px;">您上传的场所图片角度不全或清晰度不够</div>
        <div class="div_line">
          <div @click="handle()" class="btn_l">手动选择场所</div>
          <div @click="handles()" class="btn_r">重新识别</div>
        </div>
      </div>
      <img @click="disableshow = false" class="disclose" src="../assets/close.png" />
    </div>
    <evaluator-header class="mainHeader" @logout="logoutClick"></evaluator-header>
    <div class="wrapper">
      <!--<div class="section section1">-->
      <!--<div class="title">风险评测</div>-->
      <!--</div>-->
      <div class="section section2">
        <div class="image"></div>
      </div>
      <div v-if="intel == 1" class="section section3">
        <div @click="handle()" class="change">>> 手动选择场所</div>
        <div class="title title1">智能识别企业经营场所</div>
        <div style="height: 1px;width: 100%;background-color: #eee"></div>
        <!--<div class="top">请选择企业经营场所 <span>(多选)</span></div>-->
        <div v-if="imgUrl == ''" class="upload">
          <div class="plus">+</div>
          <div class="text">
            <div class="cli">点击</div>上传场所图片
          </div>
          <input type="file" id="file1" value accept="image/*" @change="getCamera($event)" />
        </div>
        <div v-else class="upload">
          <img :src="imgUrl" />
          <div class="chan">更换图片</div>
          <input type="file" id="file2" value accept="image/*" @change="getCamera($event)" />
        </div>
        <div class="text1">&nbsp;图片文件类型支持<div class="cli1">PNG、JPG、JPEG、BMP</div>，图片大小不超过<div class="cli1">4M</div>。
        </div>
        <div v-if="uploaded == 1" class="con1"></div>
        <div v-if="uploaded == 1" class="cat-title cat-title1">经营场所 <div class="cat-title-sub">(多选)</div>
        </div>
        <div v-if="uploaded == 1" class="content">
          <div v-if="unRecommendsList.length != 0" @click="plus_place()" class="cat-value-plus">
            <svg t="1578374843038" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="2188" width="23" height="23">
              <path
                d="M851.968 503.808 532.48 503.808 532.48 188.416c0-12.288-8.192-20.48-20.48-20.48S491.52 176.128 491.52 188.416l0 319.488L172.032 507.904c-12.288 0-20.48 8.192-20.48 20.48s8.192 20.48 20.48 20.48L491.52 548.864l0 319.488c0 12.288 8.192 20.48 20.48 20.48s20.48-8.192 20.48-20.48l0-319.488 319.488 0c12.288 0 20.48-8.192 20.48-20.48S864.256 503.808 851.968 503.808z"
                p-id="2189" fill="#c41335"></path>
            </svg>
          </div>
          <div class="cat-value1 cat-value" v-for="(value1,index1) in recommendsList" :key="index1"
            :class="[{'defaultItem': !value1.isSel,'isItemSel1': value1.isSel}]" @click="itemClick(value1, 1)">
            {{value1.name}}</div>
        </div>
        <el-row v-for="(value1,index1) in filterList(recommendsList)" :key="'content2' + index1">
          <div class="con1" style="margin-top: 12px;"></div>
          <div class="cat-title cat-title2" v-show="value1.isSel===1&&value1.subList.length">{{value1.name}} <div
              class="cat-title-sub">(多选)</div>
          </div>
          <div class="content">
            <div class="cat-value2 cat-value" v-show="value1.isSel===1&&value1.subList.length"
              v-for="(value2,index2) in value1.subList" :key="index2"
              :class="[{'defaultItem': !value2.isSel,'isItemSel1': value2.isSel}]" @click="itemClick2(value2,index2)">
              {{value2.name}}</div>
            <div class="content" v-show="value2.isSel===1&&value2.subList.length>0"
              v-for="(value2,index2) in value1.subList" :class="{'content4': index2 != 0,'content3': index2 == 0}"
              :key="'content3' + index2">
              <div class="cat-title cat-title3" v-show="value2.subList.length>0">{{value2.name}}</div>
              <div class="cat-value3" v-show="value2.subList.length>0" v-for="(value3,index3) in value2.subList"
                :key="index3" @click="itemClick3(value3,index3)">
                <div class="image" :class="{'defaultImage': !value3.isSel,'selImage': value3.isSel}"></div>
                <span>{{value3.name}}</span>
              </div>
            </div>
          </div>
        </el-row>
      </div>
      <div v-if="intel == 0" class="section section3">
        <div @click="handles()" class="change">>> 智能识别场所</div>
        <div class="title">请选择企业经营场所</div>
        <div style="height: 1px;width: 100%;background-color: #eee"></div>
        <!--<div class="top">请选择企业经营场所 <span>(多选)</span></div>-->
        <div class="cat-title cat-title1">经营场所 <div class="cat-title-sub">(多选)</div>
        </div>
        <div class="content">
          <div class="cat-value1 cat-value" v-for="(value1,index1) in categoryData" :key="index1"
            :class="[{'defaultItem': !value1.isSel,'isItemSel1': value1.isSel}]" @click="itemClick(value1, 1)">
            {{value1.name}}</div>
        </div>
        <el-row v-for="(value1,index1) in filterList(categoryData)" :key="'content2' + index1">
          <div class="con1" style="margin-top: 12px;"></div>
          <div class="cat-title cat-title2" v-show="value1.isSel===1&&value1.subList.length">{{value1.name}} <div
              class="cat-title-sub">(多选)</div>
          </div>
          <div class="content">
            <div class="cat-value2 cat-value" v-show="value1.isSel===1&&value1.subList.length"
              v-for="(value2,index2) in value1.subList" :key="index2"
              :class="[{'defaultItem': !value2.isSel,'isItemSel1': value2.isSel}]" @click="itemClick2(value2,index2)">
              {{value2.name}}</div>
            <div class="content" v-show="value2.isSel===1&&value2.subList.length>0"
              v-for="(value2,index2) in value1.subList" :class="{'content4': index2 != 0,'content3': index2 == 0}"
              :key="'content3' + index2">
              <div class="cat-title cat-title3" v-show="value2.subList.length>0">{{value2.name}}</div>
              <div class="cat-value3" v-show="value2.subList.length>0" v-for="(value3,index3) in value2.subList"
                :key="index3" @click="itemClick3(value3,index3)">
                <div class="image" :class="{'defaultImage': !value3.isSel,'selImage': value3.isSel}"></div>
                <span>{{value3.name}}</span>
              </div>
            </div>
          </div>
        </el-row>
      </div>
    </div>
    <bottomButton title="下一步" :state="btnState" @click="bottomClick"></bottomButton>
    <Modal v-model="showCancelTip" title="是否取消选择？" width="70%">
      <p>取消选择，对应子集选择也会取消，确定取消吗？</p>
      <div slot="footer">
        <Button type="text" @click="cancelBtn">取消</Button>
        <Button type="info" @click="sureBtn">确定</Button>
      </div>
    </Modal>
    <van-popup v-model="showPicker" :close-on-click-overlay="false" position="bottom" :style="{height:'360px' }">
      <div class="headers">
        <div class="tip">添加经营场所</div>
        <div class="close" @click="cancelClick"></div>
      </div>
      <div class="places">
        <div class="cat-value1 cat-value" v-for="(value1,index1) in unRecommendsList" :key="index1"
          :class="[{'defaultItem': !value1.isSel,'isItemSel1': value1.isSel}]" @click="itemClick(value1, 2)">
          {{value1.name}}</div>
      </div>
      <div class="bottom">
        <div class="apply" @click="sureClick" :style="{backgroundColor: activeClick?'#C41335': '#FECDCD'}">保存 </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import evaluatorHeader from '../view/evaluator-header'
import bottomButton from '../components/bottom-button'
import { Toast, Indicator } from 'mint-ui'
import wxShare from '../wx/weixin.js'
export default {
  data () {
    return {
      parentId: 0,
      categoryData: [],
      progress: 0,
      currentValue: {}, // 当前选中 一级分类
      showCancelTip: false, // 展示取消选择 提示
      btnState: 0, // 底部按钮 1 可点击 0 置灰
      intel: 1, // 1 智能 0 手动
      uploaded: 0, // 0 未识别场所图片 1 已识别
      image: '', // 图片文件
      imgUrl: '', // 图片id
      imgPath: 'http://cdn.zxzx119.com/',
      recommendsList: [], // 有关联的场所列表
      unRecommendsList: [], // 无关联的场所列表
      middleList: [],
      disableshow: false, // 无法识别场所的弹框
      showPicker: false,
      activeClick: 0
    }
  },
  watch: {
    $router () { }
  },
  computed: {},
  components: {
    evaluatorHeader,
    bottomButton
  },
  mounted () {
    var _this = this
    this.utils.isUserLogin(function (login) {
      console.log('==========' + login)
      if (login === 0) {
        Toast('您还未登录，请登录后再评测！')
        _this.$router.push({
          path: 'home'
        })
      }
    })
    // 分类
    this.loadData()
    this.binBack()
    // 微信 分享
    let imgUrl = 'http://cdn.zxzx119.com/39073939414056960'
    wxShare.wxRegister(
      '消防安全风险评测',
      '中消在线风险评测  一站式解决企业风险隐患',
      imgUrl
    )
    // 统计
    this.utils.listenEvent(13, '', window.location.href, '')
  },
  methods: {
    cancelClick () {
      this.showPicker = false
      // for (let i = 0; i < this.unRecommendsList.length; i++) {
      //   this.unRecommendsList[i].isSel = 0
      // }
      // this.activeClick = 0
    },
    sureClick () {
      // console.log(this.middleList)
      if (this.activeClick === 1) {
        this.unRecommendsList = this.filterArrs(this.unRecommendsList)
        for (let a of this.middleList) {
          a.isSel = 0
        }
        this.recommendsList = this.recommendsList.concat(this.middleList)
        this.showPicker = false
        this.activeClick = 0
        this.middleList = []
      }
    },
    filterArrs (item) { // 过滤选中的一级目录
      let arrty = item.filter((item, index) => {
        return item.isSel === 0
      })
      return arrty
    },
    filterList (array) { // 过滤选中的二级目录
      let arrs = array.filter((item, index) => {
        return item.isSel === 1 && item.subList.length > 0
      })
      return arrs
    },
    logoutClick: function () {
      // 退出登录
      this.$router.push({
        path: 'home'
      })
    },
    plus_place () {
      this.showPicker = true
    },
    handle () {
      this.btnState = 0
      this.intel = 0
      this.uploaded = 0
      this.imgUrl = ''
      this.image = ''
      this.recommendsList = []
      this.unRecommendsList = []
      this.disableshow = false
      this.categoryData.forEach((item, index) => {
        if (item.isSel === 1) {
          this.btnState = 1
        }
      })
    },
    handles () {
      this.disableshow = false
      this.uploaded = 0
      this.imgUrl = ''
      this.image = ''
      this.btnState = 0
      this.intel = 1
    },
    getCamera (e) {
      var filePath = e.target.value // 获取图片路径
      var fr = new FileReader()// 创建new FileReader()对象
      var imgObj = e.target.files[0]// 获取图片长度
      if (imgObj.size < 1048576 * 4) {
        fr.readAsDataURL(imgObj)// 将图片读取为DataUR
        var that = this
        if (filePath.indexOf('jpg') !== -1 || filePath.indexOf('JPG') !== -1 || filePath.indexOf('PNG') !== -1 || filePath.indexOf('png') !== -1 || filePath.indexOf('bmp') !== -1 || filePath.indexOf('jpeg') !== -1) {
          Indicator.open()
          fr.onload = async function () {
            that.image = imgObj
            await that.uploadImage()
          }
        } else {
          Toast('请选择正确格式的图片')
        }
      } else {
        Toast('请选择不超过4M的图片')
      }
    },
    filterArr (item) { // 过滤选中的一级目录
      let arrty = item.filter((item, index) => {
        return item.isSel === 1 && item.subList.length > 0
      })
      return arrty
    },
    uploadImage (file) {
      let url = `${this.accountUrl}/kindeditor/upload_json_qiniu`
      // let url = `http://192.168.110.234:8080/kindeditor/upload_json_qiniu`
      var that = this
      let param = new FormData()
      param.append('imgFile', this.image)
      that.axios({
        method: 'post',
        url: url,
        headers: {
          'content-type': 'multipart/form-data'
        },
        data: param
      }).then(res => {
        // console.log(res)
        that.imgUrl = that.imgPath + res.data.data.fileId
        console.log(this.imageUrl)
        that.recommendsList = []
        that.unRecommendsList = []
        that.uploaded = 0
        that.utils.GET(this.accountUrl + '/riskevalAI/checkSiteWithResult?imageUrl=' + this.imgUrl, function (response) {
          if (response.recommends.length === 0) {
            that.disableshow = true
          } else {
            that.btnState = 0
            that.recommendsList = response.recommends
            that.unRecommendsList = response.unRecommends
            for (let i = 0; i < that.recommendsList.length; i++) {
              that.recommendsList[i].isSel = 0
            }
            for (let i = 0; i < that.unRecommendsList.length; i++) {
              that.unRecommendsList[i].isSel = 0
            }
            that.uploaded = 1
            Indicator.close()
          }
        })
      }).catch(err => {
        console.log(err)
        Toast(err)
        Indicator.close()
      })
    },
    bottomClick: function (type) {
      // 提交选择 分类
      if (this.btnState === 1) {
        var _this = this
        var listTemp = []
        if (this.uploaded === 1 && this.intel === 1) {
          listTemp = this.recommendsList
        } else if (this.intel === 0) {
          listTemp = this.categoryData
        }
        var categoryIds = []
        for (let i = 0; i < listTemp.length; i++) {
          // 一级
          var item = listTemp[i]
          if (item.isSel === 1 && item.subList.length !== 0) {
            var category1 = []
            for (let j = 0; j < item.subList.length; j++) {
              // 二级
              var item2 = item.subList[j]
              if (item2.isSel === 1) {
                if (item2.subList.length <= 0) {
                  category1.push(item2.id)
                  console.log('二级 只有=======' + category1)
                } else {
                  var category2 = []
                  for (let k = 0; k < item2.subList.length; k++) {
                    // 三级
                    var item3 = item2.subList[k]
                    if (item3.isSel === 1) {
                      category2.push(item3.id)
                    }
                  }
                  if (category2.length <= 0) {
                    Toast('请选择分类')
                    return
                  } else {
                    category1 = category1.concat(category2)
                    console.log('三级 只有=======' + category1)
                  }
                }
              }
            }
            if (category1.length <= 0 && item.subList.length !== 0) {
              Toast('请选择分类')
              return
            } else {
              categoryIds = categoryIds.concat(category1)
              console.log(category1)
            }
          } else if (item.isSel === 1) {
            categoryIds.push(item.id)
          }
        }
        console.log(categoryIds)
        if (categoryIds.length <= 0) {
          Toast('请先选择企业经营场所！')
          return
        }
        let categoryIdsStr = categoryIds.join(',')
        let param = {
          siteCategoryIds: categoryIdsStr
        }
        console.log(param)
        // 提交选择 分类
        let userinfo = JSON.parse(localStorage.getItem('userinfo'))
        this.utils.POSTHeader(
          this.accountUrl + '/riskevalNew/commitSiteCategory',
          {
            phone: userinfo.tails.userinfo[0].phone
          },
          param,
          function (response) {
            _this.$router.push({
              path: 'fxcp_changsuo',
              query: {
                phoneNumber: userinfo.tails.userinfo[0].phone
              }
            })
          }
        )
      }
    },
    itemClick: function (value, i) {
      // 一级分类 点击
      this.btnState = 0
      this.activeClick = 0
      this.currentValue = value
      if (value.isSel === 1) {
        if (i === 1) {
          var show = false
          value.subList.forEach((item, index) => {
            if (item.isSel === 1) {
              show = true
            }
          })
          if (show) {
            this.showCancelTip = true
          } else {
            this.$set(value, 'isSel', 0)
          }
        } else if (i === 2) {
          for (let i = 0; i < this.unRecommendsList.length; i++) {
            let item = this.unRecommendsList[i]
            if (item.id === this.currentValue.id) {
              item.isSel = 0
            }
          }
        }
      } else {
        // value.isSel = 1
        this.$set(value, 'isSel', 1)
      }
      if (this.intel === 1) {
        this.recommendsList.forEach((item, index) => {
          if (item.isSel === 1) {
            this.btnState = 1
          }
        })
        this.unRecommendsList.forEach((item, index) => {
          if (item.isSel === 1) {
            this.activeClick = 1
          }
        })
      } else if (this.intel === 0) {
        this.categoryData.forEach((item, index) => {
          if (item.isSel === 1) {
            this.btnState = 1
          }
        })
      }
      if (i === 2) {
        this.middleList = []
        this.unRecommendsList.forEach((item, index) => {
          if (item.isSel === 1) {
            this.middleList.push(item)
          }
        })
      }
    },
    itemClick2: function (value, index) {
      // 二级分类  选择
      if (value.isSel === 1) {
        // value.isSel = 0
        this.$set(value, 'isSel', 0)
        for (let i = 0; i < value.subList.length; i++) {
          var item = value.subList[i]
          // item.isSel = 0
          this.$set(item, 'isSel', 0)
        }
      } else {
        this.$set(value, 'isSel', 1)
      }
      // 同步 数据更新 视图不更新
      // this.$set(this.categoryData[index1], 'content2', value)
    },
    itemClick3: function (value, index) {
      // 三级分类  选择
      if (value.isSel === 1) {
        // value.isSel = 0
        this.$set(value, 'isSel', 0)
      } else {
        // value.isSel = 1
        this.$set(value, 'isSel', 1)
      }
      // 同步 数据更新 视图不更新
      // this.$set(this.categoryData[index1], 'content2', value)
    },
    cancelBtn: function () {
      console.log('======================0')
      this.showCancelTip = false
    },
    sureBtn: function () {
      console.log('======================0')
      this.btnState = 0
      this.showCancelTip = false
      this.currentValue.isSel = 0
      if (this.uploaded === 1 && this.intel === 1) {
        for (let i = 0; i < this.recommendsList.length; i++) {
          let item = this.recommendsList[i]
          if (item.id === this.currentValue.id) {
            item.isSel = 0
            for (let j = 0; j < item.subList.length; j++) {
              let item2 = item.subList[j]
              item2.isSel = 0
              for (let k = 0; k < item2.subList.length; k++) {
                let item3 = item2.subList[k]
                item3.isSel = 0
              }
            }
          }
        }
        this.recommendsList.forEach((item, index) => {
          if (item.isSel === 1) {
            this.btnState = 1
          }
        })
      } else if (this.intel === 0) {
        for (let i = 0; i < this.categoryData.length; i++) {
          let item = this.categoryData[i]
          if (item.id === this.currentValue.id) {
            item.isSel = 0
            for (let j = 0; j < item.subList.length; j++) {
              let item2 = item.subList[j]
              item2.isSel = 0
              for (let k = 0; k < item2.subList.length; k++) {
                let item3 = item2.subList[k]
                item3.isSel = 0
              }
            }
          }
        }
        this.categoryData.forEach((item, index) => {
          if (item.isSel === 1) {
            this.btnState = 1
          }
        })
      }
    },
    loadData: function () {
      // this.progress = this.$route.query.progress
      // 查询 场所
      var _this = this
      this.utils.GET(this.accountUrl + '/riskevalNew/getAllSite', function (
        response
      ) {
        var result = response.data
        for (let i = 0; i < result.length; i++) {
          var item = result[i]
          item.isSel = 0
          for (let j = 0; j < item.subList.length; j++) {
            var item2 = item.subList[j]
            item2.isSel = 0
            for (let k = 0; k < item2.subList.length; k++) {
              var item3 = item2.subList[k]
              item3.isSel = 0
            }
          }
        }
        _this.categoryData = result
      })
    },
    binBack: function () {
      // 禁止后退
      history.pushState(null, null, document.URL)
      window.addEventListener('popstate', function () {
        history.pushState(null, null, document.URL)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
#evaluate-category2 {
  .dishandle {
    position: absolute;
    top: 0px;
    left: 0px;
    bottom: 0px;
    right: 0px;
    z-index: 1000;
    background: rgba(0, 0, 0, 0.7);
    .disdiv {
      width: 305px;
      position: absolute;
      top: 50%;
      height: 222px;
      background: #ffffff;
      margin-top: -150px;
      text-align: center;
      left: 50%;
      margin-left: -152px;
      .div_ti {
        margin-top: 10px;
        color: #c41335;
        font-size: 18px;
        font-weight: bold;
      }
      .div_line {
        display: flex;
        justify-content: center;
        margin-top: 17px;
        .btn_l {
          width: 100px;
          height: 35px;
          border: 1px solid #c41335;
          border-radius: 35px;
          margin-right: 5px;
          color: #c41335;
          font-size: 12px;
          line-height: 35px;
          text-align: center;
        }
        .btn_r {
          width: 100px;
          height: 35px;
          background: #c41335;
          border-radius: 35px;
          margin-left: 5px;
          color: white;
          font-size: 12px;
          line-height: 35px;
          text-align: center;
        }
      }
    }
    .disclose {
      width: 28px;
      position: absolute;
      top: 50%;
      margin-top: 88px;
      left: 50%;
      margin-left: -14px;
    }
  }

  .mainHeader {
    position: fixed;
    top: 0px;
    height: 55px;
    width: 100%;
    z-index: 500;
  }

  .wrapper {
    background-color: white;
    /*height: 100%;*/
    margin-top: 55px;
    padding-bottom: 65px;
    min-height: 400px;
  }

  .section {
    position: relative;
    width: 100%;
    margin-bottom: 0px;
    background-color: #ffffff;
  }

  .section .title {
    height: 50px;
    line-height: 50px;
    color: #000;
    font-size: 16px;
    font-weight: bold;
    margin-left: 15px;
  }

  .section3 .title {
    width: 144px;
    border-bottom: solid 3px #c41335;
    box-sizing: border-box;
  }

  .section3 .title1 {
    width: 160px;
  }

  .section3 .upload {
    width: 345px;
    height: 172px;
    border: 1px dotted #cccccc;
    border-radius: 4px;
    margin: auto;
    margin-top: 16px;
  }

  .section3 .upload .plus {
    font-size: 70px;
    color: #808080;
    font-weight: 300;
    position: absolute;
    margin-top: 5px;
    left: 50%;
    margin-left: -25px;
  }

  .section3 .upload .text {
    font-size: 12px;
    color: #808080;
    margin-top: 102px;
    position: absolute;
    left: 50%;
    margin-left: -48px;
  }

  .section3 .upload .text .cli {
    display: inline-block;
    color: #c41335;
  }

  .section3 .text1 {
    font-size: 12px;
    color: #808080;
    text-align: center;
    margin-top: 6px;
    margin-bottom: 13px;
  }

  .section3 .text1 .cli1 {
    display: inline-block;
    color: #c41335;
  }

  .section3 .upload .chan {
    width: 343px;
    height: 35px;
    background: black;
    opacity: 0.7;
    text-align: center;
    font-size: 12px;
    line-height: 35px;
    color: white;
    margin-top: 135px;
    position: absolute;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  .section3 .upload img {
    width: 343px;
    height: 170px;
    border-radius: 4px;
    position: absolute;
  }

  .section3 .upload input {
    width: 100%;
    height: 100%;
    opacity: 0;
  }

  .section1 {
    height: 50px;
  }

  .section2 {
    height: 74px;
  }

  .section2 .image {
    width: 100%;
    height: 74px;
    background-image: url("../assets/icon_evaluate.jpg");
    background-size: cover;
    background-position: center center;
  }

  .section3 {
    min-height: 400px;
    padding-bottom: 15px;
  }

  .section3 .top {
    height: 70px;
    line-height: 70px;
    color: #000;
    font-size: 16px;
    text-align: center;
  }

  .section3 .top span {
    color: #808080;
    font-size: 11px;
  }

  .section3 .change {
    position: absolute;
    right: 19px;
    top: 17px;
    font-size: 12px;
    color: #808080;
  }

  .section3 .content {
    display: flex;
    display: -webkit-flex;
    flex-wrap: wrap;
    padding: 0px 15px 0px 10px;
  }

  .section3 .con1 {
    border-top: 10px solid #eeeeee;
  }

  .section3 .content3 {
    padding: 5px 10px;
    background-color: #f9f9f9;
    margin: 0 5px;
    padding-bottom: 10px;
    margin-top: 15px;
    border: 1px solid #eeeeee;
  }

  .section3 .content4 {
    padding: 5px 10px;
    background-color: #f9f9f9;
    margin: 0 5px;
    padding-bottom: 10px;
    border: 1px solid #eeeeee;
    border-top: 0px;
  }

  .section3 .cat-title {
    color: #000;
    font-size: 16px;
    padding-top: 15px;
    padding-bottom: 9px;
    font-weight: bold;
    display: inline-block;
    margin: 0 15px;
  }

  .section3 .cat-title2 {
    color: #000;
    font-size: 16px;
    padding-top: 14px;
    padding-bottom: 9px;
    font-weight: bold;
    display: inline-block;
    /*border-top: 10px solid #eeeeee;*/
    margin-left: 0px;
    padding-left: 15px;
    /*margin-top: 12px;*/
    margin-right: 0px;
  }

  .section3 .cat-title-sub {
    color: #808080;
    font-weight: normal;
    font-size: 12px;
    display: inline-block;
  }

  .section3 .content .cat-value {
    width: 111px;
    border-radius: 4px;
    height: 45px;
    margin: 0px 0px 5px 5px;
    font-size: 11px;
    display: inline-flex;
    text-align: center;
    justify-content: center;
    align-items: Center;
    color: #808080;
    background-color: #f9f9f9;
    padding: 0px 8px;
  }

  .section3 .content .cat-value-plus {
    width: 111px;
    border-radius: 4px;
    height: 45px;
    margin: 0px 0px 5px 5px;
    text-align: center;
    background-color: #fecdcd;
    border: 1px dotted #fe9797;
    padding: 0px 8px;
    padding-top: 9px;
    /*color: #C41335;*/
    /*font-size: 29px;*/
    /*font-weight: 300;*/
  }

  /*.section3 .content .cat-value-l {*/
  /*  width: 111px;*/
  /*  border-radius: 4px;*/
  /*  height: 45px;*/
  /*  margin: 0px 0px 5px 5px;*/
  /*  !*margin: 0px 5px 5px 15px;*!*/
  /*  font-size: 11px;*/
  /*  text-align: center;*/
  /*  justify-content: center;*/
  /*  align-items: Center;*/
  /*  color: #808080;*/
  /*  background-color: #F9F9F9;*/
  /*  display: inline-flex;*/
  /*  padding: 0px 8px;*/
  /*}*/

  /*.section3 .content .cat-value-r {*/
  /*  width: 111px;*/
  /*  border-radius: 4px;*/
  /*  height: 45px;*/
  /*  margin: 0px 0px 5px 5px;*/
  /*  !*margin: 0px 0px 5px 0;*!*/
  /*  font-size: 11px;*/
  /*  text-align: center;*/
  /*  justify-content: center;*/
  /*  align-items: Center;*/
  /*  color: #808080;*/
  /*  background-color: #F9F9F9;*/
  /*  display: inline-flex;*/
  /*  padding: 0px 8px;*/
  /*}*/

  .section3 .content .cat-title3 {
    color: #000;
    font-size: 13px;
    width: 100%;
    display: inline-block;
    padding: 4px 0px;
    margin: 0px;
    font-weight: normal;
    margin-bottom: 10px;
  }

  .section3 .content .cat-value3 {
    margin: 0px 6px 7px 0px;
    color: #808080;
    display: inline-flex;
    align-items: Center;
    min-width: 100px;
  }

  .cat-value3 .image {
    left: 0px;
    top: 8px;
    width: 15px;
    height: 15px;
  }

  .cat-value3 span {
    margin-left: 7px;
  }

  .defaultImage {
    background-image: url("../assets/radio_n.png");
    background-size: cover;
    background-position: center center;
  }

  .selImage {
    background-image: url("../assets/radio_s.png");
    background-size: cover;
    background-position: center center;
  }

  .defaultItem {
    color: #000;
    border: solid #eeeeee 1px;
    box-sizing: border-box;
  }

  .isItemSel1 {
    background: #c41335 !important;
    box-sizing: border-box;
    color: white !important;
  }
  .isItemSel {
    border: solid #c41335 1px !important;
    box-sizing: border-box;
    color: #c41335 !important;
  }
  .headers {
    position: relative;
    width: 100%;
    height: 45px;
    line-height: 45px;
    color: #000000;
    font-size: 15px;
    box-sizing: border-box;
  }
  .headers .close {
    position: absolute;
    top: 15px;
    right: 15px;
    width: 15px;
    height: 15px;
    padding: 5px;
    background-image: url("../assets/icon-pay-close.png");
    background-size: cover;
    background-position: center center;
  }
  .headers .tip {
    position: absolute;
    left: 0px;
    right: 0px;
    padding-left: 15px;
    font-weight: bold;
  }
  .bottom {
    position: absolute;
    width: 100%;
    bottom: 0px;
    height: 65px;
    line-height: 65px;
    background-color: #ffffff;
  }
  .bottom .apply {
    position: absolute;
    top: 10px;
    left: 15px;
    height: 45px;
    line-height: 45px;
    width: calc(100% - 30px);
    font-size: 16px;
    color: #ffffff;
    text-align: center;
    background-color: #c41335;
    border-radius: 4px;
  }

  .places {
    overflow: auto;
    height: 250px;
    padding: 0px 15px 0px 10px;
  }

  .cat-value {
    width: 111px;
    border-radius: 4px;
    height: 45px;
    margin: 0px 0px 5px 5px;
    font-size: 11px;
    display: inline-flex;
    text-align: center;
    justify-content: center;
    align-items: Center;
    color: #808080;
    background-color: #f9f9f9;
    padding: 0px 8px;
  }

  /*.cat-value-l {*/
  /*  width: 111px;*/
  /*  border-radius: 4px;*/
  /*  height: 45px;*/
  /*  margin: 0px 0px 5px 5px;*/
  /*  font-size: 11px;*/
  /*  text-align: center;*/
  /*  justify-content: center;*/
  /*  align-items: Center;*/
  /*  color: #808080;*/
  /*  background-color: #F9F9F9;*/
  /*  display: inline-flex;*/
  /*  padding: 0px 8px;*/
  /*}*/

  /*.cat-value-r {*/
  /*  width: 111px;*/
  /*  border-radius: 4px;*/
  /*  height: 45px;*/
  /*  margin: 0px 0px 5px 5px;*/
  /*  font-size: 11px;*/
  /*  text-align: center;*/
  /*  justify-content: center;*/
  /*  align-items: Center;*/
  /*  color: #808080;*/
  /*  background-color: #F9F9F9;*/
  /*  display: inline-flex;*/
  /*  padding: 0px 8px;*/
  /*}*/
}
</style>



// WEBPACK FOOTER //
// src/view/evaluate-category2.vue